export default __webpack_public_path__ + "static/OpenSans-ExtraBold-081d2724c871d44f2e9f7b464b5ec5f4.woff2";